<template>
  <div>
    <sweet-modal blocking title="User Log History Download (Punch In/Punch Out)" ref="modalUsersLogHistory" class="modal" v-on:close="closeModal">

      <el-select v-model="filter" placeholder="Filter" size="mini" style="margin-bottom: 20px; margin-right: 20px;">
        <el-option v-for="item in filterList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
          @click.native="loadList()">
        </el-option>
      </el-select>

      <el-date-picker
        size="mini"
        v-model="date"
        style="margin-right: 10px;"
        prefix-icon="el-icon-date"
        type="daterange"
        align="center"
        format="d MMM yy"
        value-format="timestamp"
        range-separator=""
        start-placeholder="Start date"
        end-placeholder="End date"
        @change="loadList()">
      </el-date-picker>
      
      <el-checkbox-group v-model="checkList">

        <el-table :data="list" element-loading-text="Loading" border>
          <el-table-column label="First Name">
            <template slot-scope="scope">
              {{ scope.row.firstName }}
            </template>
          </el-table-column>
          <el-table-column label="Last Name">
            <template slot-scope="scope">
              {{ scope.row.lastName }}
            </template>
          </el-table-column>
          <el-table-column label="Status" align="center">
            <template slot-scope="scope">
              {{ scope.row.status == 1 ? 'Active' : 'Inactive' }}
            </template>
          </el-table-column>
          <el-table-column label="Download" align="center">
            <template slot-scope="scope">
              <el-checkbox :label="scope.row.userId">&nbsp;</el-checkbox>
            </template>
          </el-table-column>
        </el-table>

      </el-checkbox-group>

      <el-row :gutter="20" style="margin-top: 20px;">
        <el-col style="text-align: right;" :span="24" :offset="0">
          <downloadexcel
            v-if="checkList.length"
            class="btn download-excel-button"
            :fetch="uploadExcel"
            :fields="json_fields">
            Download
          </downloadexcel>
        </el-col>
      </el-row>

    </sweet-modal>
  </div>
</template>

<script>
import downloadexcel from "vue-json-excel";
let moment = require('moment')
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import axios from 'axios'
export default {
  components: {
    SweetModal,
    downloadexcel,
  },
  props: ['modalHistoryInvite'],
  watch: {
    checkList: function (val) {
      this.forExcel(val)
    },
  },
  data() {
    return {
      list: [],
      filter: null,
      date: [],
      checkList: [],
      listExcel: [],
      filterList: [{id: null, name: 'Select All'},{id: true, name: 'Select Active'},{id: false, name: 'Select Inactive'}],

      json_fields: {
        UserID: "userId",
        UserName: "userName",
        Datetime: "datetime",
        Remarks: "action",
      },
    }
  },
  methods: {
    openModal() {
      this.$refs['modalUsersLogHistory'].open()
      // this.loadList()
    },
    loadList() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/user-logs/list?companyId=${this.$route.query.companyId}&startDate=${this.date[0] ? (this.date[0] / 1000) : null}&endDate=${this.date[1] ? (this.date[1] / 1000) : null}&status=${this.filter}`)
        .then(response => {
          this.list = response.data.list
          loader.hide()
        })
        .catch(error => {
          loader.hide()
          console.log('An error occurred:', error);
          this.notification("Notification", this.$t(error.response.data.message), "info");
        });
    },
    forExcel(val) {
      let loader = this.$loading.show();
      this.listExcel = []
      let arr = []
      for (let i = 0; i < this.list.length; i++) {
        const even = (element) => element === this.list[i].userId;
        if (val.some(even)) {
          // this.listExcel.push(this.list[i].logs)
          for (let k = 0; k < this.list[i].logs.length; k++) {
            this.list[i].logs[k].datetime = moment(this.list[i].logs[k].datetime * 1000).format('MM/DD/YYYY, h:mm:ss a')
            this.listExcel.push(this.list[i].logs[k])
          }
        }
      }
      loader.hide();
    },
    async uploadExcel() {
      try {
        let loader = this.$loading.show();

        const table = this.listExcel;

        loader.hide();

        return table;
      } catch (err) {
        console.log(err);
      }
    },
    closeModal() {
      this.list = []
      this.filter = null
      this.date = []
      this.checkList = []
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
  },
}
</script>

<style lang="scss" scoped>
  /deep/.el-range-separator{
    position:relative;
    &::before{
      color: #C0C4CC;
      font-family: "element-icons";
      position:absolute;
      content: "\E78E";
      left:5px;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
    }
  }

  .download-excel-button {
    margin-left: 10px;
    font-size: 12px;
    border-radius: 3px;
    padding: 7px 15px;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #409EFF;
    border: 1px solid #dcdfe6;
    color: #FFF;
    -webkit-appearance: none;
    text-align: center;
    transition: 0.1s;
    font-weight: 500;
    box-sizing: border-box;
    outline: 0;
    &:hover {
      background: #66b1ff;
      border-color: #66b1ff;
      color: #FFF;
    }
  }
</style>
